/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import { withRouter } from "react-router-dom";

import Constants from "app_constants";
import Theme from "./theme";

const blogPosts = Constants.blogPosts;

const renderBlogPost = (title, summary, img, link) => {
  return (
    <div className="column">
      <div className="card">
        <div className="card-image">
          <figure className="image is-4by3">
            <img
              onClick={() => window.open(link, "_blank")}
              src={img}
              className="postImg"
            />
          </figure>
        </div>
        <div className="card-content">
          <a href={link} className="title is-5" target="_blank">
            {title}
          </a>
          <br /> <br />
          <div className="content">{summary}</div>
        </div>
      </div>
    </div>
  );
};

const Resources = (props) => {
  return (
    <Theme>
      {Constants.metaTag}

      <section className="hero is-info">
        <div className="hero-body">
          <div className="container">
            <h1 className="title">Useful Resources about Remote Working</h1>
            <h2 className="subtitle">
              Discover blog posts, contract templates and contract signing
              platforms on this page.
            </h2>
          </div>
        </div>
      </section>

      <br />

      <h5 className="title is-5">Blog Posts</h5>

      <div className="columns">
        {blogPosts
          .slice(0, 3)
          .map(({ title, summary, img, link }) =>
            renderBlogPost(title, summary, img, link)
          )}
      </div>

      <div className="columns">
        {blogPosts
          .slice(3, 5)
          .map(({ title, summary, img, link }) =>
            renderBlogPost(title, summary, img, link)
          )}
      </div>

      <br />

      <h5 className="title is-5">Developer Coding Assessment Platforms</h5>

      <div className="contract box">
        <img
          onClick={() => window.open("https://www.hackerrank.com", "_blank")}
          src="https://res.cloudinary.com/svmszcck/image/upload/v1572169479/hackerrank_b90p1i.png"
          width="80"
        />

        <span>Practice coding, prepare for interviews, and get hired.</span>
      </div>

      <div className="contract box">
        <img
          onClick={() => window.open("https://www.qualified.io", "_blank")}
          src="https://res.cloudinary.com/svmszcck/image/upload/v1572169591/qualified-logo.cbab2cf.52e2f6f_xxrhby.png"
          width="80"
        />

        <span>
          Coding assessments that test real world skills, not algorithms.
        </span>
      </div>

      <br />

      <h5 className="title is-5">Application Form Builders</h5>

      <div className="contract box">
        <img
          onClick={() => window.open("https://breezy.hr", "_blank")}
          src="https://res.cloudinary.com/svmszcck/image/upload/v1572031143/Breezy_HR_CaseStudy_FeaturedImage_kcg2eh.png"
          width="60"
        />

        <span>
          End-to-end recruiting software to help you attract & hire great
          employees with less effort
        </span>
      </div>

      <div className="contract box">
        <img
          onClick={() => window.open("https://www.workable.com", "_blank")}
          src="https://res.cloudinary.com/svmszcck/image/upload/v1572031298/90840-1420645019-059576_npumnq.png"
          width="60"
        />

        <span>Workable is the world’s leading hiring platform</span>
      </div>

      <br />

      <h5 className="title is-5">Contract Templates</h5>

      <div className="contract box">
        <img
          onClick={() =>
            window.open("https://www.docsketch.com/contracts", "_blank")
          }
          src="https://res.cloudinary.com/svmszcck/image/upload/v1572010519/5NPm2PEN_400x400_ued8se.jpg"
          width="50"
        />

        <span>
          Contract Templates and Agreements (From 25,000 Sales Documents)
        </span>
      </div>

      <div className="contract box">
        <img
          onClick={() =>
            window.open(
              "https://www.pandadoc.com/standard-business-document-templates",
              "_blank"
            )
          }
          src="https://res.cloudinary.com/svmszcck/image/upload/v1572010897/y6GdBuYT_400x400_ezuiwh.jpg"
          width="50"
        />

        <span>Contract Templates and Agreements with Free Samples</span>
      </div>

      <div className="contract box">
        <img
          onClick={() =>
            window.open("https://www.template.net/editable/contracts", "_blank")
          }
          src="https://res.cloudinary.com/svmszcck/image/upload/v1572011765/y23j6-7hszb_lwjzmo.png"
          width="50"
        />

        <span>Free ready-made contract templates</span>
      </div>

      <br />

      <h5 className="title is-5">Contract Signing Platforms</h5>

      <div className="contract box">
        <img
          onClick={() => window.open("https://eversign.com", "_blank")}
          src="https://res.cloudinary.com/svmszcck/image/upload/v1571992931/ever-sign_tw2i7p.png"
          width="80"
        />

        <span>
          Legally binding electronic signatures at work, at home or on the go.
          Securely approve, deliver and sign documents online
        </span>
      </div>

      <div className="contract box">
        <img
          onClick={() => window.open("https://www.hellosign.com", "_blank")}
          src="https://res.cloudinary.com/svmszcck/image/upload/v1571993234/hello-sign_zeitea.png"
          width="80"
        />

        <span>Effortless eSignatures Trusted by Millions</span>
      </div>

      <br />

      <p>
        <b>Do you want to ask something?</b>
      </p>

      <br />

      <button
        onClick={() => {
          props.history.push("/contact");
          window.scrollTo(0, 0);
        }}
        className="button is-info is-rounded"
      >
        <span className="icon is-small">
          <i className="fas fa-envelope"></i>
        </span>
        <span>Contact Us</span>
      </button>
    </Theme>
  );
};

export default withRouter(Resources);
